export default {"src":"/_next/static/media/file-icon.4851f787.svg","height":24,"width":24};